import { Badge, Input, Page } from "@theg1group/ui";
import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { GraphView } from "../components/GraphView.tsx";

export function GraphPage() {
	const [params, setParams] = useSearchParams();
	const [focus, setFocus] = useState(params.get("focus") ?? "");
	const focusBrand = params.get("focusBrand") ?? undefined;

	return (
		<Page
			title="Infrastructure Graph"
			description="Messages, domains, hosts, IPs, nameservers, ESPs, selectors and their relationships."
			actions={
				focusBrand ? (
					<div className="flex items-center gap-2">
						<Badge variant="success">brand: {focusBrand}</Badge>
						<Link
							to="/graph"
							className="text-primary text-sm hover:underline"
							onClick={() => {
								setParams({});
								setFocus("");
							}}
						>
							clear
						</Link>
					</div>
				) : (
					<form
						onSubmit={(e) => {
							e.preventDefault();
							setParams(focus ? { focus } : {});
						}}
						className="flex gap-2"
					>
						<Input
							value={focus}
							onChange={(e) => setFocus(e.target.value)}
							placeholder="Focus domain (blank = all)"
						/>
					</form>
				)
			}
		>
			<GraphView focusDomain={params.get("focus") ?? undefined} focusBrand={focusBrand} />
		</Page>
	);
}
